import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';



export const findBrand = () => {
    return request({
        url: `${baseUrl}/joins-sales/v1/brand`,
        method: 'GET'
    })
}
export const invoiceSystemV2Put = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/put/listV2?` + params,
        method: 'GET'
    })
}

export const invoiceSystemV2PutAdd = (data) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/put`,
        method: 'POST',
        data: data
    })
}

export const invoiceSystemV2PutPut = (data) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/put/put`,
        method: 'POST',
        data: data
    })
}
export const findGoodsDetail = (id, params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop_goods/goodsDetail?id=${id}&` + params,
        method: 'GET'
    })
}

export const findGoodsDetailList = (id, params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/put/history/${id}?` + params,
        method: 'GET'
    })
}
export const invoiceSystemV2PutEdit = (data) => {
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/put`,
        method: 'PUT',
        data: data
    })
}

export const invoiceSystemV2PutDownload = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/put/downloadExcel?` + params,
        method: 'GET'
    })
}
export const findGoodsDetailListDownload = (id, params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/put/history/downloadExcel/${id}?` + params,
        method: 'GET'
    })
}
export const goodsDown = (ids) => {
    let temp = ids.join(",")
    console.log(temp)
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/put/changeStatus/${temp}?status=SOLD_OUT`,
        method: 'PUT'
    })
}
export const goodsPutAway = (ids) => {
    let temp = ids.join(",")
    return request({
        url: `${baseUrl}/joins-invoice-system/v2/put/changeStatus/${temp}?status=SOLD_IN`,
        method: 'PUT'
    })
}





export const findGoodsDetailSku = (id, params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/shop_goods/showGoodsDetail?id=${id}&` + params,
        method: 'GET'
    })
}





export const chooseSecondClassify = (id) => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/choose?superiorId=${id}`,
        method: 'GET'
    })

}
export const findClassify = () => {
    return request({
        url: `${baseUrl}/joins-sales/v1/classify/choose/agent`,
        method: 'GET'
    })
}
export const findConstituteBySkuId = (id) => {
    return request({
        url: `${baseUrl}/joins-product/v1/sku/constitute/${id}`,
        method: 'GET'
    })
}
export const findSku = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/sku/list?` + params,
        method: 'GET'
    })
}

export const chooseFirstSku = (id) => {
    return request({
        url: `${baseUrl}/joins-product/v1/sku/list/agent?firstClassifyId=${id}`,
        method: 'GET'
    })
}

export const findProductSkuClassify = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-product/v1/sku/list/agent?` + params,
        method: 'GET'
    })
}